import SeasonCard from "./SeasonCard";

export default SeasonCard;
